import { HttpMethod } from "../../enums/HttpMethod";
import { apiFetch } from "../helpers";
import IAPICaseProducts from "../../interfaces/api/IAPICaseProduct";

/**
 *
 * API Calls
 *
 */

export const startApplicationAPI = async (
    groupId: string,
    providerId: number,
    caseProduct: IAPICaseProducts[]
): Promise<string> => {
    const apiBody = {
        collectionID: 0,
        groupID: groupId,
        provider: providerId,
        providerId,
        caseProduct
    };

    const collectionId = await apiFetch<number>(`/api/v1/collection/create`, {
        method: HttpMethod.Post,
        body: JSON.stringify(apiBody),
        headers: {
            "Content-Type": "application/json"
        }
    });

    return apiFetch<string>(`/api/v1/groups/${groupId}/apply/start/${collectionId}`, {
        method: HttpMethod.Post
    });
};
